import React from 'react';

const Header = () => {
    return (
        <div className="header">
            <h1>Sparrow Schools Educational Trust</h1>
            <p>Featured Courses</p>
        </div>
    );
};

export default Header;
